export default function TrustStats() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-widest text-foreground-500 font-label mb-3">Trusted Since 2026</p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
          Why <span className="italic text-primary-500">Shoppers</span> Choose
          <br />
          Mulebuy Spreadsheet
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-lg">
          Structured shopping for European &amp; Western buyers who value efficiency and transparency.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-accent-100/60 rounded-lg p-8 md:p-10 relative group hover:bg-accent-100 transition-colors duration-300">
            <span className="font-heading text-7xl md:text-8xl font-bold text-accent-600">98%</span>
            <p className="mt-3 text-foreground-700 text-sm leading-relaxed max-w-xs">
              Of users report a more organized shopping experience after adopting the <strong>Mulebuy spreadsheet</strong> method.
            </p>
            <p className="mt-2 text-xs text-foreground-500 italic">Faster product discovery. Better price tracking.</p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="bg-secondary-100/60 rounded-lg p-8 md:p-10 relative group hover:bg-secondary-100 transition-colors duration-300">
            <span className="font-heading text-7xl md:text-8xl font-bold text-secondary-600">14+</span>
            <p className="mt-3 text-foreground-700 text-sm leading-relaxed max-w-xs">
              Product categories available through the Mulebuy spreadsheet system, covering everything from shoes to accessories.
            </p>
            <p className="mt-2 text-xs text-foreground-500 italic">Comprehensive. Structured. Easy to browse.</p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}